import { CallController } from '@gem/call/CallController/CallController';
import { Call } from '@gem/call/CallStore/Call';
import * as callModel from '@gem/call/Model/callModel';
import { FinishCallReason } from '@gem/call/Model/callModel.types';
import { logger } from '@gem/modules/logger';

export const finishAll = async (params: {
  call: Call;
  callController: CallController;
}): Promise<void> => {
  try {
    const call = params.call;
    if (!call) {
      return;
    }

    if (call.channelId && params.callController.handlers.feedbackHandler) {
      params.callController.handlers.feedbackHandler(call.channelId);
    }

    if (call.channelId) {
      await callModel.finishCall(call.channelId, FinishCallReason.FinishAll);
    }
    params.callController.dispose();
  } catch (e) {
    logger.get('API').error('calls.finishAll', e);
  }
};
